package music.limasoul.client.shared.event.domain.usecase

import music.jammers.client.shared.event.domain.repository.EventRepository
import music.jammers.shared.event.domain.model.Event
import music.jammers.shared.event.domain.model.EventData

class CreateEventUseCase(
    private val eventRepository: EventRepository,
) {

    suspend operator fun invoke(eventDataModel: EventData): Event =
        eventRepository.create(eventDataModel)
}